<ng-container *ngIf="show">
  <!-- Overlay -->
  <div class="fixed inset-0 z-80 bg-black/30 backdrop-blur-sm flex items-center justify-center">
    <!-- Modal Content -->
    <div
      class="relative bg-white rounded-lg shadow-2xl flex flex-col w-[95vw] max-w-[55%] h-[95%] max-h-[95%] overflow-hidden">
      <!-- Header -->
      <div class="flex items-center justify-between py-6 border-b border-gray-200">
        <span
          style="color: #1F2937; font-family: Inter, sans-serif; font-size: 20px; font-style: normal; font-weight: 400; line-height: 20px;"
          class="px-[5%]">
          Report Details: {{ fileNumber }}
        </span>

          <i class="pi pi-times px-[5%] cursor-pointer" style="color: #1F2937;" (click)="onClose()"></i>
      </div>
      <!-- PDF/Spinner Area -->
      <div class="flex-1 flex items-center justify-center relative h-[70%]">
        <app-spinner [isLoading]="isLoading" *ngIf="isLoading"
          style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 40; display: flex; align-items: center; justify-content: center;"></app-spinner>
        <ng-container *ngIf="pdfUrl; else noReport">
          <iframe [src]="pdfUrl | safeUrl" (load)="onPdfLoad()" class="w-[90%] h-[99%]" title="View Report"></iframe>
        </ng-container>
        <ng-template #noReport>
          <span class="text-3xl text-gray-400">PDF</span>
        </ng-template>
      </div>
      <!-- Footer -->
      <div class="flex justify-end items-center gap-4 px-[5%] py-3 bg-white border-t border-gray-200">
        <button type="button" (click)="downloadReport()"
          class="flex items-center gap-2 h-10 px-6 rounded-lg bg-gray-100 hover:bg-gray-200 text-base text-gray-700 transition-colors cursor-pointer">
          <i class="pi pi-file-pdf text-xl"></i> Download Report
        </button>
        <button type="button" (click)="onClose()"
          class="h-10 w-28 rounded-lg bg-black text-white hover:bg-gray-800 text-base transition-colors cursor-pointer">Close</button>
      </div>
    </div>
  </div>
</ng-container>